import { render, staticRenderFns } from "./partner-customer-multiselect-ajax.vue?vue&type=template&id=6b18203d&scoped=true&"
import script from "./partner-customer-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./partner-customer-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18203d",
  null
  
)

export default component.exports